import * as PasswordConstants from '../../password/constants';

const initialState = {
  isLoading: false,
  valid: false
};

export function physicianCheck(state = initialState, action) {
  switch (action.type) {
    case PasswordConstants.PHYSICIAN_CHECK_STARTED:
      return Object.assign({}, state, {isLoading: true, valid: false});
    case PasswordConstants.PHYSICIAN_CHECK_COMPLETED:
      return Object.assign({}, state, {isLoading: false, valid: action.valid});
    default:
      return state;
  }
}
